import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const NGS = () => {
    return <section className='NGS'>
        <MatchTable betType='NGS'/>
        <Remark />
    </section>
}
export default NGS;